export const inboxSignatureShortCode = inboxId =>
  inboxId ? `firma_alias_${inboxId}` : '';

export const getInboxSignature = ({
  inboxId,
  cannedResponses = [],
  fallback = '',
}) => {
  const shortCode = inboxSignatureShortCode(inboxId);
  if (!shortCode) return fallback;

  return (
    cannedResponses.find(item => item.short_code === shortCode)?.content ||
    fallback
  );
};
